import Class from './c-content-chart-gantt-view';
import './c-content-chart-gantt-view@.vue';

export default Class;
